export default __webpack_public_path__ + "static/media/0f273e76-ee34-42e5-b565-500186dc2f5b.f2b1790e.jpeg";